import { withInstall } from '../../../utils/with-install'
import ThreePolygon from './ThreePolygon.vue'

export const ElAmapThreePolygon = withInstall(ThreePolygon)
export default ElAmapThreePolygon
